export const START_PLAY = 'START_PLAY';
export const PAUSE_PLAY = 'PAUSE_PLAY';

export const SET_TRACK = 'SET_TRACK';

